import IconField from 'components/Form/Fields/IconField';

import React from 'react';

export default function MoneyField({ prepend = 'money-bill', ...props }) {
    return <IconField prepend={prepend} type="number" {...props} />;
}
